module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"service-orders":"Lista de Ordens de serviço","status":"Status","request-number":"Nº do pedido","type":"Tipo","request-date":"Data","observation":"Observação"},"en-US":{"service-orders":"Service orders","status":"Status","request-number":"Order Nº","type":"Type","request-date":"Date","observation":"Observation"}}')
  delete Component.options._Ctor
}
